import { useEffect, useState } from "react";
import { authenticatedFetch } from "../JWTAuthService";
import { configuration } from "../Configuration";
import { buildTree } from "../administration/din276/din276Tree";
import { dinUnitResolver } from "./conformityDisplay";
import type { UnitResolver } from "./conformityTypes";

/**
 * Fetches the DIN-276 ontology once and returns a {@link UnitResolver} that maps a
 * conformity atom's `part` ref (typeCode + attributeName) to its canonical unit.
 * Units are optional chrome — on failure the resolver is simply absent and atoms
 * render without a unit.
 */
export function useDinUnitResolver(enabled: boolean = true): UnitResolver | undefined {
  const [resolver, setResolver] = useState<UnitResolver>();

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    (async () => {
      try {
        const resp = await authenticatedFetch(`${configuration.serverUrl}/metadata/din276`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!resp || !resp.ok) return;
        const data = await resp.json();
        if (cancelled) return;
        const tree = buildTree(Array.isArray(data) ? data : []);
        setResolver(() => dinUnitResolver(tree.byCode));
      } catch {
        /* units are optional */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return resolver;
}
